export const permissoesCadastroPesquisa = [
  process.env.VUE_APP_ADMINISTRADOR,
  process.env.VUE_APP_PESQUISA_SATISFACAO_CADASTRO_VISUALIZAR_CONDICIONADO,
  process.env.VUE_APP_PESQUISA_SATISFACAO_CADASTRO_EDITAR_CONDICIONADO,
  process.env.VUE_APP_PESQUISA_SATISFACAO_CADASTRO_TOTAL,
]

export const permissoesRelatoriosPesquisa = [
  process.env.VUE_APP_ADMINISTRADOR,
  process.env.VUE_APP_PESQUISA_SATISFACAO_RELATORIO_VISUALIZAR_CONDICIONADO,
  process.env.VUE_APP_PESQUISA_SATISFACAO_RELATORIO_OUVIR_GRAVACAO,
  process.env.VUE_APP_PESQUISA_SATISFACAO_RELATORIO_HISTORICO,
  process.env.VUE_APP_PESQUISA_SATISFACAO_RELATORIO_OUVIR_GRAVACAO_HISTORICO,
  process.env.VUE_APP_PESQUISA_SATISFACAO_RELATORIO_TOTAL,
]
